import { useQuery } from "@apollo/client";
import { GET_FESTIVAL_SETTINGS } from "../graphql";
import { LoadingOverlay } from "../../../components/Loading";
import { ISettingsProps } from "../form";
import { SuperAdminSettingsForm } from "./form";

export const SuperAdminTab = () => {
  const { data, error, loading } = useQuery(GET_FESTIVAL_SETTINGS);

  if (loading) return <LoadingOverlay loading={loading} />;

  const defaults: ISettingsProps = {
    editionId: "",
    // @ts-expect-error
    setting: {
      downForMaintenance: false,
      minVersion: "0.0.1",
    },
  };

  return (
    <SuperAdminSettingsForm
      // @ts-ignore
      setting={data?.settings[0] ?? defaults.setting}
      versionNumber={data?.versionNumber ?? defaults.versionNumber}
    />
  );
};
